import { isBrowser } from "./env-utils";

export const lerTextoEmVoz = async (texto: string, lang = "pt-BR") => {
  if (!isBrowser || !window?.speechSynthesis) {
    console.error("Este ambiente não suporta a Web Speech API");
    return;
  }

  const utterance = new SpeechSynthesisUtterance(texto);
  utterance.lang = lang;
  utterance.rate = 1.2;
  utterance.pitch = 1;

  const carregarVozes = (): Promise<SpeechSynthesisVoice[]> => {
    return new Promise((resolve) => {
      const voices = window?.speechSynthesis.getVoices();
      if (voices.length) {
        resolve(voices);
      } else {
        if (isBrowser) {
          window.speechSynthesis.onvoiceschanged = () =>
            resolve(window?.speechSynthesis.getVoices());
        }
      }
    });
  };

  const vozes = await carregarVozes();
  const voz = vozes.find((v) => v.lang === lang);

  if (voz) utterance.voice = voz;
  window?.speechSynthesis.cancel();
  window?.speechSynthesis.speak(utterance);
};

export const cancelarVoz = async () => {
  if (!isBrowser || !window?.speechSynthesis) {
    console.error("Este ambiente não suporta a Web Speech API");
    return;
  }

  window?.speechSynthesis.cancel();
};
